function setupPurchaseOptionToggle() {
  const depositRadio = document.getElementById("purchase-option-deposit-input");
  const depositBtnWrapper = document.getElementById("deposit-button-wrapper");
  const standardBtnWrapper = document.getElementById("standard-button-wrapper");

  const purchaseOptionsText = document.getElementById(
    "hypehound-customer-info"
  );
  const infoWrapper = document.getElementById("purchase-option-info-wrapper");

  if (!depositRadio || !depositBtnWrapper || !standardBtnWrapper) {
    console.warn("Elements not found. Retrying...");
    return setTimeout(setupPurchaseOptionToggle, 300); // Retry until elements exist
  }

  let termsTextEl;
  termsTextEl = document.createElement("p");
  termsTextEl.style.marginTop = "0.5rem";
  termsTextEl.style.fontSize = "16px";
  termsTextEl.innerHTML =
    'See full terms <a href="https://ellavatewagon.com/pages/reservations-terms-agreements" style="text-decoration: underline;font-weight: bold;">here.</a>';

  function toggleButtons() {
    const depositChecked = depositRadio.checked;

    depositBtnWrapper.style.display = depositChecked ? "block" : "none";
    standardBtnWrapper.style.display = depositChecked ? "none" : "block";

    if (purchaseOptionsText) {
      if (depositChecked) {
        infoWrapper.appendChild(termsTextEl);
      } else {
        infoWrapper.removeChild(termsTextEl);
      }
    }
  }

  // Attach listeners
  document
    .querySelectorAll('input[name="purchase_option"]')
    .forEach((radio) => {
      radio.addEventListener("change", toggleButtons);
    });

  toggleButtons(); // Initial state
  window.toggleButtons = toggleButtons; // Safe to attach now
}

document.addEventListener("DOMContentLoaded", setupPurchaseOptionToggle);

window.addEventListener("pageshow", function (event) {
  const isBack =
    event.persisted ||
    performance.getEntriesByType("navigation")[0]?.type === "back_forward";
  if (isBack) {
    if (typeof window.toggleButtons === "function") {
      window.toggleButtons();
    } else {
      console.warn("toggleButtons not ready. Reloading...");
      window.location.reload();
    }
  }
});
